import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Reserve from "../components/reserve/Reserve";
import CreateDebtReceivable from "../components/finance/CreateDebtReceivable";
import EditDebtReceivable from "../components/finance/EditDebtReceivable";
import Receivable from "../components/finance/Receivable";
import ToPay from "../components/finance/ToPay";
import CreateDebtToPay from "../components/finance/CreateDebtToPay";
import EditDebtToPay from "../components/finance/EditDebtToPay";
import Aliquots from "../components/finance/Aliquots";
import CommonCosts from "../components/finance/CommonCosts";
import CreateCommonCosts from "../components/finance/CreateCommonCosts";
import CreateAliquot from "../components/finance/CreateAliquot";
import EditAliquot from "../components/finance/EditAliquot";
import { FinanceRouteProtected,ProtectedRoute } from "../helpers/ProtectedRoute";
import LegacyRouteRedirect from "../helpers/LegacyRouteRedirect";
import Payments from "../components/finance/Payments";
import PropertyPaymentDetail from "../components/finance/PropertyPaymentDetail";
import Advance from "../components/finance/Advance";
import MyService from "../components/finance/MyService";
import MyPaymentService from "../components/finance/MyPaymentService";
import ManagerServicePayment from "../components/finance/ManagerServicePayment";
import ManagerServicePaymentDetails from "../components/finance/ManagerServicePaymentDetails";
import CreateCommonIncome from "../components/finance/CreateCommonIncome";
import CommonIncome from "../components/finance/CommonIncome";
import ReserveFund from "../components/reserve/ReserveFund";
import CreateReserveFund from "../components/reserve/CreateReserveFund";
import CurrentFund from "../components/reserve/CurrentFund";
import CreatePaymentFund from "../components/reserve/CreatePaymentFund";

const FinanceRoutes = ({ match: { url } }) => (
  <Switch>
    <Route path={`${url}/`} exact component={Reserve} />

    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service`}
      component={MyService}
    />
    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge`}
      component={MyPaymentService}
    />
    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge/payment`}
      component={ManagerServicePayment}
    />
    <ProtectedRoute
      exact
      rols={["manager"]}
      path={`${url}/:condominiumId/my/service/:charge/:paymentId`}
      component={ManagerServicePaymentDetails}
    />

    <FinanceRouteProtected path={`${url}/advance`} exact component={Advance} />
    <Route path={`${url}/:id`} exact component={Reserve} />
    {/* TO RECEIVE AS CONDOMINIUM */}
    <FinanceRouteProtected
      path={`${url}/:id/receivable`}
      exact
      component={Receivable}
    />
    <FinanceRouteProtected
      path={`${url}/:id/receivable/detail/:debtReceivedId`}
      exact
      component={EditDebtReceivable}
    />
    <ProtectedRoute
      path={`${url}/:id/receivable/create`}
      rols={["manager"]}
      component={CreateDebtReceivable}
    />
    {/* TO PAY AS CONDOMINIUM */}
    <FinanceRouteProtected path={`${url}/:id/topay`} exact component={ToPay} />
    <FinanceRouteProtected
      path={`${url}/:id/topay/edit/:debtToPayId`}
      exact
      component={EditDebtToPay}
    />
    <ProtectedRoute
      path={`${url}/:id/topay/create`}
      rols={["manager"]}
      component={CreateDebtToPay}
    />

    <FinanceRouteProtected
      path={`${url}/:id/aliquots`}
      exact
      component={Aliquots}
    />
    <FinanceRouteProtected
      path={`${url}/:id/aliquots/edit/:aliquotId`}
      exact
      component={EditAliquot}
    />
    <ProtectedRoute
      path={`${url}/:id/aliquots/create`}
      rols={["manager"]}
      component={CreateAliquot}
    />

    <FinanceRouteProtected
      path={`${url}/:id/common-costs`}
      exact
      component={CommonCosts}
    />
    <ProtectedRoute
      path={`${url}/:id/common-costs/create`}
      rols={["manager"]}
      component={CreateCommonCosts}
    />

    <FinanceRouteProtected
      path={`${url}/:id/common-income`}
      exact
      component={CommonIncome}
    />
    <ProtectedRoute
      path={`${url}/:id/common-income/create`}
      rols={["manager"]}
      component={CreateCommonIncome}
    />

    <FinanceRouteProtected
      path={`${url}/:id/reserve`}
      exact
      component={ReserveFund}
    />
    <ProtectedRoute
      path={`${url}/:id/reserve/create`}
      rols={["manager"]}
      component={CreateReserveFund}
    />

    <FinanceRouteProtected
      path={`${url}/:id/cash`}
      exact
      component={CurrentFund}
    />
    <ProtectedRoute
      path={`${url}/:id/cash/create`}
      rols={["manager"]}
      component={CreatePaymentFund}
    />

    <FinanceRouteProtected
      path={`${url}/:id/payments`}
      exact
      component={Payments}
    />
    <FinanceRouteProtected
      path={`${url}/:id/payments/:propertyPayment`}
      exact
      component={PropertyPaymentDetail}
    />

    <LegacyRouteRedirect />
  </Switch>
);

FinanceRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(FinanceRoutes);
